import {ActionReducerMap} from '@ngrx/store';
import {IAppState} from '../state/app.state';
import {routerReducer} from '@ngrx/router-store';
import {configReducers} from './config.reducers';
import {userReducers} from './user.reducers';
import {enterpriseReducers} from "./enterprise.reducer";
import {adnetReducers} from "./adnet.reducer";
import {fasterqReducers} from "./fasterq.reducers";

export const appReducers: ActionReducerMap<IAppState, any> = {
    router: routerReducer,
    users: userReducers,
    adnet: adnetReducers,
    enterprise: enterpriseReducers,
    config: configReducers,
    fasterq: fasterqReducers
};
